import React from 'react'
import { Button, Header, Message, Segment } from 'semantic-ui-react'
import Link from 'next/link'
import { format } from 'date-fns'

import { useAuth } from 'lib/context/AuthContext'
import WhySubscribeModal from 'lib/components/WhySubscribeModal'

const NotSubscribed = () => (
  <>
    <Header size="medium">
      Not subscribed
      <Header.Subheader>
        <WhySubscribeModal />
      </Header.Subheader>
    </Header>
    <p></p>
    <Link href="/user/subscription" passHref>
      <Button size="large" as="a" color="green">
        Subscribe now
      </Button>
    </Link>
  </>
)

const Monthly = () => (
  <>
    <Header size="medium">Subscribed</Header>
    <p>
      You are on the <strong>Monthly</strong> plan. Switch to yearly billing and
      get 2 months free!
    </p>
    <Link href="/user/subscription" passHref>
      <Button as="a" primary>
        Manage Subscription
      </Button>
    </Link>
  </>
)

const Annual = () => (
  <>
    <Header size="medium">Subscribed</Header>
    <p>
      You are on the <strong>Yearly</strong> plan.
    </p>
    <Link href="/user/subscription" passHref>
      <Button as="a" primary>
        Manage Subscription
      </Button>
    </Link>
  </>
)

const Cancelled = ({ subscription_end }) => (
  <>
    <Header size="medium">Subscribed - Cancelled</Header>
    <p>
      You have cancelled your plan. Your plan is active until{' '}
      {format(subscription_end * 1000, 'MMM do, yyyy')}.
    </p>
    <Link href="/user/subscription" passHref>
      <Button as="a" primary>
        Manage Subscription
      </Button>
    </Link>
  </>
)

const Content = ({ plan, cancelled, subscription_end }) => {
  if (cancelled) {
    return <Cancelled subscription_end={subscription_end} />
  }

  if (!plan) {
    return <NotSubscribed />
  }

  if (plan === 'personal-monthly') {
    return <Monthly />
  }

  if (plan === 'personal-yearly') {
    return <Annual />
  }

  console.error('no subscription content found')
  return null
}

const Plan = ({}) => {
  const [user] = useAuth()

  const { plan, cancelled, subscription_end } = user.data.stripe ?? {}

  return (
    <>
      <Message
        attached="top"
        header="Subscription"
        content="Manage your subscription"
        size="tiny"
      />
      <Segment className="attached">
        <Content
          plan={plan}
          cancelled={cancelled}
          subscription_end={subscription_end}
        />
      </Segment>
    </>
  )
}

export default Plan
